import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';

import { GATEWAY_DOWNLOADS } from 'enum/gateway';
import ConfigOptions from './ConfigOptions';
import './styles.scss';

const panelSx = {
  mb: 2,
  border: '1px solid #ddd',
  borderRadius: '4px',
  boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
};
const panelHeadingSx = {
  px: '15px',
  py: '10px',
  backgroundColor: '#f5f5f5',
  borderBottom: '1px solid #ddd',
  borderTopLeftRadius: '3px',
  borderTopRightRadius: '3px',
};
const panelBodySx = {
  p: '15px',
};

const GatewayDevices = ({ data }) => {
  const [searchText, setSearchText] = useState('');
  const [isCollapsed, setIsCollapsed] = useState({
    'Bare Metal, OS, and Software': false,
    'VM and Cloud Images': false,
    'SBC and IoT Images': false,
  });

  const handleSearchChange = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setSearchText(value);
    setIsCollapsed(
      Object.keys(isCollapsed).reduce((acc, key) => {
        acc[key] = !!value;
        return acc;
      }, {}),
    );
  };

  const openCollapse = (title) => (event) => {
    event.preventDefault();
    setIsCollapsed((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  const searchOptions = (label) => !searchText || label.toLowerCase().includes(searchText.toLowerCase());

  return (
    <div className="panel__downloads">
      <Box className="panel" sx={panelSx}>
        <Box className="panel-heading" sx={panelHeadingSx}>
          <input placeholder="Search" onChange={handleSearchChange} />
          <SearchIcon className="search-icon" />
        </Box>
        <Box className="panel-body" sx={panelBodySx}>
          {GATEWAY_DOWNLOADS.map(
            (downOption) =>
              downOption[data.gateway_type] && (
                <div key={`key-${downOption.title}`} className="download-list" data-testid={downOption.title}>
                  <span className="download-list__label" onClick={openCollapse(downOption.title)}>
                    {isCollapsed[downOption.title] ? (
                      <ExpandMoreIcon />
                    ) : (
                      <ExpandMoreIcon sx={{ transform: 'rotate(-90deg)' }} />
                    )}
                    {downOption.title}
                  </span>
                  <Collapse in={isCollapsed[downOption.title]}>
                    <div className="download-list__collapse">
                      {downOption.options.map(
                        (option) =>
                          searchOptions(option.label) && (
                            <ConfigOptions key={option.value} option={option} gateway={data} />
                          ),
                      )}
                    </div>
                  </Collapse>
                </div>
              ),
          )}
        </Box>
      </Box>
    </div>
  );
};

GatewayDevices.propTypes = {
  data: PropTypes.object.isRequired,
};

export default GatewayDevices;
